import React from 'react'
import TechStatsPage from '../Trends/TechStatsPage'

function TechStatPage() {
  return (
    <>
        <TechStatsPage />
    </>
  )
}

export default TechStatPage
